<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-progress-linear
        indeterminate
        :active="isRequestingNow.length > 0"
        color="blue"
        class="mb-0"
      ></v-progress-linear>
      <v-overlay :value="pageLoading">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <v-flex v-if="!pageLoading && revenue" style="position: relative">
        <v-container class="grey lighten-5">
          <v-row no-gutters class="pagination-table-header">
            <v-col
              cols="12"
              class="py-md-0"
            >
              <v-card
                class="pa-1 px-2"
                style="position: relative"
              >
                <v-row>
                  <v-col
                    cols="12"
                    class="cyan white--text"
                  >
                    <div class="white--text">
                      <v-icon
                        class="mr-2 white--text"
                      >
                        mdi-map-marker
                      </v-icon>
                      {{ lang($store, 'sap/listings.global.filter.hints.region') }}:
                      {{ $t('enums.region.' + revenue.region) }}
                    </div>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      :value="moment(revenue.accounting_date).format(DATE_VIEW)"
                      prepend-icon="mdi-calendar-clock"
                      :label="$t('table.headers.date')"
                      autocomplete="off"
                      disabled
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-checkbox
                      :value="revenue.is_subscription"
                      :label="$t('table.headers.subscription')"
                      color="yellow darken-2"
                      :false-value="0"
                      :true-value="1"
                      disabled
                    ></v-checkbox>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      :value="$t(`enums.order_category_types.${revenue.order_category}`)"
                      :label="$t('general.category')"
                      prepend-icon="mdi-format-list-bulleted-type"
                      autocomplete="off"
                      disabled
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      :value="getType()"
                      :label="$t('table.headers.type')"
                      prepend-icon="mdi-format-list-bulleted-type"
                      autocomplete="off"
                      disabled
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                  >
                    <v-text-field
                      type="number"
                      v-model="revenue.amount"
                      prepend-icon="mdi-cash-100"
                      :label="$t('table.headers.sum')"
                      autocomplete="off"
                      :error-messages="(errors && errors.amount)?errors.amount:null"
                      @input="removeError('amount')"
                      @change="updateRequest('amount', $event)"
                      :loading="isRequestingNow.includes('amount')"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    v-if="revenue.is_subscription"
                    cols="12"
                  >
                    <v-text-field
                      type="number"
                      v-model="revenue.amount_with_additions"
                      prepend-icon="mdi-cash-100"
                      :label="$t('table.headers.sum') + ' (' + $t('table.headers.additional_services') + ')'"
                      autocomplete="off"
                      :error-messages="(errors && errors.amount_with_additions)?errors.amount_with_additions:null"
                      @input="removeError('amount_with_additions')"
                      @change="updateRequest('amount_with_additions', $event)"
                      :loading="isRequestingNow.includes('amount_with_additions')"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import i18n from '@/i18n';
/* constants */
import { DATE_VIEW } from '@/constants/dates';

/* utils */
import { prepareValidationMessages } from '@/utils';
import { router } from '@/plugins/vue-router';
import moment from 'moment';

/* proxies */
import RevenueProxy from '@/proxies/Revenue/RevenueProxy';

/* mixins */
import updatePageContentMixin from '@/mixins/updatePageContentMixin';
import validationMixin from '@/mixins/validationMixin';
import {MANAGER_TOP} from "@/constants/roles";

export default {
  name: 'RevenueShow',
  mixins: [
    updatePageContentMixin,
    validationMixin,
  ],
  data() {
    return {
      moment,
      DATE_VIEW,
      pageLoading: false,
      isShowHistory: false,
      shouldSeeLoaderOnUpdating: true,
      isRequestingNow: [],
      pricing: null,
      revenue: null,
      errors: {},
    };
  },
  created() {
    if (! (this.account.role === MANAGER_TOP && this.account.phone == '+380 (73) 060-66-00')) {
      router.push({ name: 'home.default' });
      return;
    }

    this.pageLoading = true;
    this.fetchData();
  },
  computed: {
    account() {
      return this.$store.getters['account/account'];
    },
  },
  watch: {
    '$route.params.uuid': {
      handler() {
        this.fetchData();
      },
    },
  },
  methods: {
    fetchData() {
      new RevenueProxy().find(this.$route.params.uuid)
        .then((response) => {
          this.revenue = response.data.data.revenue;
        })
        .catch((error) => {
          console.error(error);
          return this.$router.push({
            name: 404,
          });
        })
        .finally(() => {
          this.pageLoading = false;
          this.$store.dispatch('page/finishUpdateCurrentPageContent');
        });
    },
    updateRequest(property, val) {
      if (!this.pageLoading) {
        this.isRequestingNow.push(property);
        (this.updateSimpleRequest(this.revenue, property))(val)
          .catch((response) => {
            this.$nextTick(() => {
              if (response && response.data && 'data' in response.data) {
                this.errors = {
                  ...this.errors,
                  ...prepareValidationMessages(response.data.data),
                }
              }
            });
          })
          .finally(() => {
            const index = this.isRequestingNow.indexOf(property);
            if (index !== -1) this.isRequestingNow.splice(index, 1);
          });
      }
    },
    updateSimpleRequest(revenue, property) {
      console.log(revenue.uuid);

      return value => {
        const data = {};
        data[property] = value;
        return (new RevenueProxy()).update(revenue.uuid, data);
      };
    },
    getType() {
      let type = '';
      if (this.revenue.order_category === 'base') {
        type = `${this.lang(this.$store, `sap/listings.global.filter.order_base_types.${this.revenue.order_type}`)}`;
      }
      if (this.revenue.order_category === 'complex') {
        type = `${this.lang(this.$store, `sap/listings.global.filter.order_complex_types.${this.revenue.order_type}`)}`;
      }
      return type;
    },
  },
};
</script>

<style scoped lang="scss">


</style>
